import { FilterOption, isValidEntityType } from "../types";
import { ENTITY_TYPE_PARAMETER } from "../helpers/constants/miscellaneous";
import { useSelector } from "react-redux";
import { getEntityTypeFilter } from "../redux/SingleDataset/selectors";
import useAllQueryParamsFilters from "./useAllQueryParamsFilters";

export const useEntityTypeFilter = () => {
  const queryParamsFilters = useAllQueryParamsFilters();
  const entityTypeFromQueryParam = isValidEntityType(
    queryParamsFilters[ENTITY_TYPE_PARAMETER],
  )
    ? queryParamsFilters[ENTITY_TYPE_PARAMETER]
    : null;
  const entityTypeFilter = useSelector((state) =>
    getEntityTypeFilter(state, entityTypeFromQueryParam),
  );

  const selectedEntityTypes = entityTypeFilter.filter(
    (option: FilterOption) => option.selected,
  );

  if (!selectedEntityTypes.length) {
    selectedEntityTypes.push(
      entityTypeFilter.find(
        (entity) => entity.text.toLowerCase() === "images",
      )!,
    );
  }
};
